import BossModel from "@/models/BossModel";

export default class Type extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/discount/type';

    /**
     *
     * @type {string}
     */
    static entity = 'productDiscountTypes';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			code: this.attr(null),
			is_active: this.attr(null),
			agent_name: this.attr(null),
		}
	}


}
